<template>
  <page class="home-page">
    <zui-header>
      <logo type="xiaoyanyun" href="/"></logo>
      <h4 class="zui-logo-text">
        |&nbsp;&nbsp;国潮国色 让爱美丽
        <br/>|&nbsp;&nbsp;让家健康 让社会更美好
      </h4>
      <el-dropdown class="zui-rightcol" @command="handleCommand" trigger="click">
        <span class="el-dropdown-link">
          网站导航<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <template v-for="(zbtn,zi) in headBtn">
            <el-dropdown-item :command="zbtn.key" :key="zi">{{zbtn.text}}</el-dropdown-item>
          </template>
        </el-dropdown-menu>
      </el-dropdown>
      <template v-for="(zbtn,zi) in headBtn">
        <zui-button @click="onButtonClick(zbtn.key)" :key="zi" :class="activeFlag(zbtn.key)?'active':''">{{zbtn.text}}</zui-button>
      </template>
    </zui-header>

    <div id="wrapper" class="pcWrapper">
      <!--focus start-->
      <div id="FocusBG" class="pcFocusBG joinFocusBG">
        <img src="../assets/img/join/an_bg.jpg" class="inside_top_bg">
      </div>


      <!--focus end-->
      <!--body start-->
      <div id="body">
        <!--inner start -->
        <div class="inner">
          <!--right start-->
          <div class="right">
            <div class="PosLeft">联系我们</div>
            <!--main start-->
            <div class="main">

              <!--content start-->
              <div class="content">
                <div class="maincontent clearfix">
                  <nav>
                    <div class="contact_con_tit">
                      上海珂立诺新材料科技有限公司
                    </div>
                    <div class="con_contact">
                      <ul>
                        <li>
                          <img src="../assets/img/about/icon90.png">
                          <p>
                            地址
                          </p>
                          <span>上海市奉贤区南桥镇西闸公路566号</span>
                        </li>
                        <li>
                          <img src="../assets/img/about/icon91.png">
                          <p>
                            热线
                          </p>
                          <span>13576298878</span>
                        </li>
                        <li>
                          <img src="../assets/img/about/icon93.png">
                          <p>
                            网址
                          </p>
                          <span>www.korlinor.com</span>
                        </li>
                      </ul>
                    </div>
                   <div class="clearfix"></div>
                  </nav>
                </div>


              </div>
              <!--content end-->

            </div>
            <!--main end-->
          </div>
          <!--right end-->
          <div class="clearfix"></div>
        </div>
        <!--inner end-->
      </div>
      <!--body end-->
      <div class="HeightTab clearfix"></div>

    </div>

    <zui-footer/>
  </page>
</template>
<script>
  import '../assets/less/home-page.less'
  import Logo from '../components/portal/Logo'
  import Page from '../components/portal/Page'
  import ZuiHeader from '../components/portal/Header'
  import ZuiFooter from '../components/portal/Footer'
  import ZuiButton from '../components/portal/Button'
  import Util from '../Util'
  export default{
    components: {
      Page, Logo, ZuiHeader, ZuiFooter,ZuiButton
    },
    data () {
      return {
        carouselPerPage: (Util.os.android || Util.os.iPhone) ? 1 : 2
      }
    },
    methods: {
    }
  }
</script>
<style>
  .c1{
    width: 80%;
    margin: 0 auto;
  }
</style>
